import { Credentials } from "../Common/Types/types";
import httpClient from "./http";
import axios from "axios";
import { baseUrl } from "../Common/Constants";


class _AuthApi {
  loginTest(): Promise<any> {
    let url = "auth";
    return httpClient
      .get<any>(url)
      .then((response) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  }

    async login(creds: Credentials): Promise<boolean> {
        const tokenUrl = baseUrl + "auth/token";
        const loginUrl = baseUrl + "auth";

        try {
            const tokenResponse = await axios.get<{ token: string }>(tokenUrl, {
                withCredentials: true,
            });

            const token = tokenResponse.data.token;

            await axios.post(loginUrl, creds, {
                headers: {
                    "X-CSRF-TOKEN": token,
                },
                withCredentials: true,
            });

            return true;
        } catch {
            return false;
        }
    }

    async logout(): Promise<boolean> {
        const tokenUrl = baseUrl + "auth/token";
        const logoutUrl = baseUrl + "auth";

        try {
            const tokenResponse = await axios.get<{ token: string }>(tokenUrl, {
                withCredentials: true,
            });
            const token = tokenResponse.data.token;

            await axios.delete(logoutUrl, {
                headers: {
                    "X-CSRF-TOKEN": token,
                },
                withCredentials: true,
            });

            return true;
        } catch {
            return false;
        }
    }
    logUserEventDetail(page: string, customerID: string, machineSerial: string): Promise<boolean> {
        const url = "UserAnalytics";
        const body = {
            page,
            event: "detail",                 // or some meaningful string if you use it
            userAgent: navigator.userAgent,
            customerID,
            machineSerial,
        };

        return httpClient
            .post<any>(url, body)
            .then(() => true);
    }

    logUserEvent(page: string): Promise<boolean> {
        const url = "UserAnalytics";
        const body = {
            page,
            event: "simple",                 // or whatever you want here
            userAgent: navigator.userAgent,
            customerID: null,
            machineSerial: null,
        };

        return httpClient
            .post<any>(url, body)
            .then(() => true);
    }


}
export const AuthApi = new _AuthApi();
